import React from "react";
import { useTranslation } from "react-i18next";

// Rendered by react-router as errorElement, so it must not depend on any lazy
// chunk — plain HTML only, otherwise it can fail for the very reason it shows.
export default function RouteErrorPage() {
  const { t } = useTranslation();

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        background: "#f9f9f9",
        color: "#333",
      }}
    >
      <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
        {t("common.errorHappened")}
      </h1>
      <p style={{ maxWidth: "400px", color: "#666" }}>
        {t("common.networkErrorDesc")}
      </p>
      <button
        type="button"
        style={{
          marginTop: "2rem",
          padding: "8px 24px",
          border: "none",
          borderRadius: "6px",
          background: "#1677ff",
          color: "#fff",
          cursor: "pointer",
        }}
        onClick={() => window.location.reload()}
      >
        {t("common.refresh")}
      </button>
    </div>
  );
}
